import { doc, loc, nav, win } from "src/global";
import { getNetworkType, isInIframe } from "src/utils";
import getWindowTitle from "src/utils/get-window-title";
import { isMobile } from "src/utils/webview";
import getDvid from "src/utils/get-dvid";

export default (): ClientInfo => {
  let topHost = '';
  let topUrl = '';
  try {
    topHost = win.top.location.host;
    topUrl = win.top.location.href;
  } catch (error) {
    topHost = 'Blocked';
    topUrl = 'Blocked';
  }
  return {
    pfm: isMobile ? 'h5' : 'web',
    tgap: -1,
    host: loc.host,
    topHost,
    url: loc.href,
    topUrl,
    ptit: getWindowTitle(true),
    ua: nav.userAgent,
    dm: nav.deviceMemory,
    hcc: nav.hardwareConcurrency,
    sh: win.screen.height,
    sw: win.screen.width,
    inf: isInIframe() ? 1 : 0,
    la: win.globalization?.locale || nav.language,
    ntk: getNetworkType(),
    rf: doc.referrer,
    dvid: getDvid(),
    // emf: '',
    // ebrand: '',
    // emodel: '',
  };
}
